import Extension from "../base/extension";

class Nav extends Extension {
  #section;
  navDesktopOverlay;
  navDesktopItems;

  constructor(name) {
    super(name);
  }

  init() {
  this.#section = document.querySelector('.section-header');
  this.navDesktopOverlay = document.querySelector('.nav-desktop-overlay');
  this.navDesktopItems = document.querySelectorAll('#navbar nav .navbar-nav .nav-item.menu.dropdown');

  this.setupScrollListener();
  document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
  document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));

  this.hoverEffectOnDesktop();
  }

  onScrollDown(e) {
    if (e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-up');
      this.#section.classList.add('scrolled-down');
    }
  }

  onScrollUp(e) {
    if (e.detail.difference > 5) {
      this.#section.classList.remove('scrolled-down');
      this.#section.classList.add('scrolled-up');
    }
  }

  setupScrollListener() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener("scroll", () => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      let difference = Math.abs(st - lastScrollTop);

      if (st > lastScrollTop) {
        document.dispatchEvent(new CustomEvent("interaction:down-scroll", { detail: { difference } }));
      } else {
        document.dispatchEvent(new CustomEvent("interaction:up-scroll", { detail: { difference } }));
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }, false);
  }

  hoverEffectOnDesktop() {
    document.querySelectorAll('.dropdown').forEach(dropdown => {
      // Setup dynamic hover delay for navigation items
      this.setupHoverDelay();

      // Only apply overlay hover to megamenu dropdowns — utility dropdowns (e.g. account) must be excluded
      document.querySelectorAll('.nav-item.menu.dropdown:not(.nav-item-hover-delay)').forEach(dropdown => {
        let hideTimeout;

        dropdown.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout);
          if (this.navDesktopOverlay) {
            this.navDesktopOverlay.classList.add('show');
          }
        });

        dropdown.addEventListener('mouseleave', () => {
          hideTimeout = setTimeout(() => {
            if (this.navDesktopOverlay) {
              this.navDesktopOverlay.classList.remove('show');
            }
          }, 100);
        });
      });
    });
  }

  setupHoverDelay() {
    // Find all nav items with hover delay
    const navItems = document.querySelectorAll('.nav-item-hover-delay');
    
    navItems.forEach(function(item) {
      // Set the CSS custom property for transition-delay (200ms)
      if (item instanceof HTMLElement) {
        item.style.setProperty('--hover-delay', '200ms');
      }
    });
  }
}

export default Nav;
